import { render, staticRenderFns } from "./UidTokenGuidePopup.vue?vue&type=template&id=3556ca84&scoped=true&"
import script from "./UidTokenGuidePopup.vue?vue&type=script&lang=js&"
export * from "./UidTokenGuidePopup.vue?vue&type=script&lang=js&"
import style0 from "./UidTokenGuidePopup.vue?vue&type=style&index=0&id=3556ca84&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556ca84",
  null
  
)

export default component.exports